import React from 'react';
  // import { logger } from '../utils/logger';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
}

const SEO = React.memo(({ title, description, keywords, canonical }: SEOProps) => {
  const fullTitle = title ? `${title} | Nucleus AI` : 'Nucleus AI';

  // React.memo prevents unnecessary re-renders when props haven't changed
  // Uncomment for debugging SEO rendering issues in development:
  // logger.debug(`SEO component rendered: ${fullTitle}`);
  
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </>
  );
});

SEO.displayName = 'SEO';

export default SEO; 